import { render } from "./AboutUs.vue?vue&type=template&id=074e9564&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=074e9564&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074e9564"]])

export default __exports__